import React from 'react';
import { Box, FormControl, InputLabel, Select, MenuItem, Button } from '@mui/material';

const Sort = ({ sort, onSortChange, children }) => {
  const handleFieldChange = (index, event) => {
    const newField = event.target.value;
    const newSort = [...sort];
    const currentDirection = Object.values(newSort[index])[0];
    newSort[index] = { [newField]: currentDirection };
    onSortChange(newSort);
  };

  const handleDirectionChange = (index, event) => {
    const newDirection = event.target.value;
    const newSort = [...sort];
    const currentField = Object.keys(newSort[index])[0];
    newSort[index] = { [currentField]: newDirection };
    onSortChange(newSort);
  };

  const addSortCondition = () => {
    onSortChange([...sort, { '': 1 }]);
  };

  const removeSortCondition = (index) => {
    const newSort = sort.filter((_, i) => i !== index);
    onSortChange(newSort);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 2, alignItems : 'flex-end' }}>
      {sort.map((sortCondition, index) => {
        const field = Object.keys(sortCondition)[0];
        const direction = sortCondition[field];
        return (
          <Box key={index} sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
            Tri :
            <FormControl  variant="standard">
              <Select
                value={field}
                label="Field"
                onChange={(event) => handleFieldChange(index, event)}
              >
                {React.Children.map(children, child => {
                  if (React.isValidElement(child)) {
                    return React.cloneElement(child, { key: child.props.value });
                  }
                  return child;
                })}
                {/* Ajoutez d'autres champs de tri ici */}
              </Select>
            </FormControl>
            <FormControl  variant="standard">
              <Select
                value={direction}
                label="Sort"
                onChange={(event) => handleDirectionChange(index, event)}
              >
                <MenuItem value={1}>Croissant</MenuItem>
                <MenuItem value={-1}>Décroissant</MenuItem>
              </Select>
            </FormControl>
            {/*
                <Button onClick={() => removeSortCondition(index)}>Remove</Button>
            */}
            
          </Box>
        );
      })}
      {/*
        <Button onClick={addSortCondition}>Add Sort Condition</Button>
      */}
    </Box>
  );
};

export default Sort;